import { defineComponent as _defineComponent } from 'vue'
import router from "@/router";
import { Toast } from "vant";
import { onMounted, ref, onUnmounted } from "vue";
import { hostRankingList } from "@/api/php/home";
import { usePiniaState } from "@/store/userPinia";
import { encryptionFocusHost } from "@/api/php/user";
import { storeToRefs } from "pinia"
import { cheackQuery, nativeToLogin, ToBack } from "@/uitls/native";
import { useRoute } from "vue-router";
import { useI18n } from 'vue-i18n'

export default /*#__PURE__*/_defineComponent({
  name: 'HotZb',
  setup(__props, { expose }) {
  expose();

const { t } = useI18n()
const route = useRoute();
const piniaStore = usePiniaState();
const { isYk } = storeToRefs(piniaStore);
onMounted(() => {
    cheackQuery(route);
    getHostRankingList()
    document
        .querySelector("body")
        .setAttribute("style", "background-color:#000;");
});
onUnmounted(() => {
    document
        .querySelector("body")
        .setAttribute("style", "background-color:#fff;");
});

const back = () => {
    router.back()
}
const hotzb = ref([])
const listzb = ref([])
//获取明星主播的数据
const getHostRankingList = async () => {
    const res: any = await hostRankingList({
        type: 1
    });
    if (res && res.code == 200) {
        hotzb.value = res.data;
        listzb.value = res.data.slice(3, res.data.length);
    }
}
//去关注
const toStar = async (id: string) => {
    if (isYk.value) {
        return nativeToLogin(router);
    }
    const res: any = await encryptionFocusHost({
        host_id: JSON.stringify([id])
    })
    if (res.code == 200) {
        Toast.success(t('me.gzcg'))
        getHostRankingList()
    }
}
const enStart = async (id) => {
    //取消关注这个主播
    const res: any = await encryptionFocusHost({
        host_id: id,
        del: 1
    })
    if (res.code == 200) {
        Toast.success(t('me.quxiaocg'))
        getHostRankingList()

    }
}



const __returned__ = { t, route, piniaStore, isYk, back, hotzb, listzb, getHostRankingList, toStar, enStart, router, ToBack }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})